import { render, staticRenderFns } from "./statement-import-list.vue?vue&type=template&id=e3d7ec10&scoped=true"
import script from "./statement-import-list.vue?vue&type=script&lang=ts"
export * from "./statement-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d7ec10",
  null
  
)

export default component.exports